import React, { useState } from "react";
import InquiryToCustomer from "../../../types/Entities/InquiryToCustomer";
import { Divider, Stack, Typography } from "@mui/material";
import ValidatorTextField from "../../FormFields/ValidatorTextField";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import InquiryToCustomerMediaObjects from "./InquiryToCustomerMediaObjects";
import InquiryToCustomerDocument from "./InquiryToCustomerDocument";

type InquiryToCustomerDocumentsBoxProps = {
  inquiryToCustomer: InquiryToCustomer;
  product: AbstractCase;
  hideMediaObjects?: boolean;
};

export default function InquiryToCustomerDocumentsBox({ inquiryToCustomer, product, hideMediaObjects = false }: InquiryToCustomerDocumentsBoxProps) {
  const [isFileUploading, setIsFileUploading] = useState(false);

  if (!inquiryToCustomer.requestedDocuments) {
    return null;
  }

  return (
    <Stack spacing={2}>
      <Typography variant={"h4"} sx={{ textAlign: "center" }}>
        Benötigte Dokumente
      </Typography>
      {!!inquiryToCustomer.inquiryTextDocuments && (
        <>
          <Typography sx={{ whiteSpace: "pre-wrap" }}>
            <strong>
              <u>Wichtige Hinweise zu den benötigten Dokumenten:</u>
            </strong>
          </Typography>
          <Typography sx={{ color: "text.primary" }} dangerouslySetInnerHTML={{ __html: inquiryToCustomer.inquiryTextDocuments }} />
        </>
      )}
      {!hideMediaObjects && <InquiryToCustomerMediaObjects inquiryToCustomer={inquiryToCustomer} />}
      {inquiryToCustomer.requestedDocuments.map((document, index) => {
        return (
          <React.Fragment key={"inquiryDocument" + index}>
            <InquiryToCustomerDocument
              document={document}
              inquiryToCustomer={inquiryToCustomer}
              index={index}
              product={product}
              onHandleUploading={setIsFileUploading}
              isBlocked={isFileUploading}
            />
            {index + 1 !== inquiryToCustomer.requestedDocuments?.length && <Divider />}
          </React.Fragment>
        );
      })}
      {!inquiryToCustomer.hideInquiryTextDocumentsCustomer && (
        <ValidatorTextField
          label="Ihre Anmerkungen und Fragen (optional)"
          name="inquiryTextDocumentsCustomer"
          placeholder={"Sie haben Anmerkungen oder Fragen zu den angefragten Dokumenten, dann teilen Sie uns diese gerne kurz hier mit."}
          multiline
          rows={5}
          InputLabelProps={{
            shrink: true,
          }}
        />
      )}
    </Stack>
  );
}
